import periodCardIconComponent from './periodCardIcon.component';

let periodCardIconModule = angular.module('vacations-absences.periodCardIcon', [])

.component('periodCardIcon', periodCardIconComponent)

.name;

export default periodCardIconModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodCard/periodCardIcon/periodCardIcon.js